import script from "./PaymentMethodEfectivo.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodEfectivo.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodEfectivo.vue?vue&type=style&index=0&id=c36c0518&scoped=true&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c36c0518"]])

export default __exports__